import { render, staticRenderFns } from "./ReportFinanceMarginReportSummary.vue?vue&type=template&id=0b76c819"
import script from "./ReportFinanceMarginReportSummary.vue?vue&type=script&lang=js"
export * from "./ReportFinanceMarginReportSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports